module.exports = __webpack_public_path__ + "static/media/CV-Mixail-Malliotakis.6f52e7b0.pdf";